import { NgModule } from 'ng-metadata/core';
import {TagsService} from './tags.service';
import {PrmTags} from './tags.directive';
import {TagsListModule} from './tagsList/tagsList.module';
import {TagsSearchBarModule} from './tagsSearchBar/tagsSearchBar.module';
import {TagsResultsModule} from './tagsResults/tagsResults.module';


@NgModule({
    declarations: [
        PrmTags
    ],
    providers: [
        TagsService
    ],
    imports:[
        TagsListModule, TagsSearchBarModule, TagsResultsModule
    ]
})
export class TagsModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/tags/tags.module.ts